




import { Component, Vue } from 'vue-property-decorator'
import { mdiMultiplication } from '@mdi/js'

@Component
class RequiredStar extends Vue {
  icon = mdiMultiplication
}

export default RequiredStar
